export default "__VITE_ASSET__9aJC6rIJ__"